import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ApiService } from 'src/app/api.service';
import { AppComponent } from 'src/app/app.component';
import { ThemingService } from 'src/app/theming.service';
import { LambdaService } from 'src/app/lambda.service';
declare var $: any;

@Component({
  selector: 'app-client',
  templateUrl: './client.component.html',
  styleUrls: ['./client.component.scss']
})
export class ClientComponent implements OnInit {

  clientId = 0;
  client: any = {};
  beneficiaries: any;
  sales: any[] = [];
  saleStateName: any;
  amplifyClientConfig: any = {};

  emptySales = false;
  searchString: string = '';
  currentPage: number = 1;
  amount: number = 20;

  loading: boolean = false;
  plans: any[] = [];
  modalDelete: boolean = false;
  hasPlans: boolean = false;
  expandedPlanId: number | null = null;
  constructor(
    public appComponent: AppComponent,
    private apiService: ApiService,
    public themingService: ThemingService,
    public route: ActivatedRoute,
    private lambdaService: LambdaService,
  ) {
    this.route.paramMap.subscribe((params) => {
      let clientId = Number(params.get('clientId'));
      if (clientId != this.clientId) {
        this.appComponent.goToTop();
        this.clientId = clientId;
      }
    });
    this.amplifyClientConfig = JSON.parse(this.themingService.shopTheming[0].amplifyConfig);
   }

   async ngOnInit(): Promise<void> {
    this.saleStateName = {
      0: 'Cancelado',
      1: 'Pendiente de verificación',
      2: 'Preparando orden',
      3: 'Entregado',
      4: 'Pendiente Compra Click',
      5: 'Completado',
      6: 'Parcial'
    };
    await this.getClient();
    this.getClientSales();

}

  async getClient() {
    this.loading = true;
    await this.lambdaService
      .getClient(
        this.themingService.shopId,
        this.clientId
      )
      .then((data: any) => {
        this.client = data.client;
        this.beneficiaries = data.beneficiaries;
      }).catch((error: Error)=>{
        console.log(error)
      })
    this.loading = false;
  }

  async getClientSales(){
    this.loading = true;
    await this.lambdaService
      .getClientSales(
        this.client.nationalId,
        this.currentPage - 1,
        this.amount,
        this.searchString,
        this.themingService.shopTheming[0].shopId
      )
      .then((data: any) => {
        this.sales = data.map((sale: any) => {
          sale.saleShortCode = sale.saleOrderCode.substring(
            sale.saleOrderCode.length - 5
          );
          sale.saleDate = this.appComponent.formatDate(sale.saleDate);
          let dateArray = sale.saleDate.split(",");
          sale.saleOnlyDate = dateArray[0];
          return sale;
        });
        console.log("final sales: ",this.sales);
        this.extractPlans();
        if(this.sales.length == 0){
          this.emptySales = true;
        }
      });
    this.loading = false;
  }

  formatDate(dateString: any) {
    return this.appComponent.formatShortDate(dateString);
  }

  extractPlans() {
    const result: any[] = [];
    let uniqueId = 0;

    this.sales.forEach((sale: any) => {
      sale.saleItems?.forEach((item: any) => {
        if (item.productType === 3 || item.productType === 4) {
          result.push({
            productName: item.productName,
            shopPointName: sale.shopPointName,
            saleDate: sale.saleOnlyDate,
            status: item.status,
            itemId: item.itemId,
            saleId: sale.saleId,
            quantity: item.quantity,
            unitPrice: item.unitPrice,
            paymentMethod: sale.paymentMethod || 'N/A',
            saleOrderCode: sale.saleOrderCode,
            productType: item.productType,
            beneficiaries: item.beneficiaries,
            imageURL: item.imageURL,
            uniqueId: uniqueId++
          });
        }
      });
    });

    this.plans = result;
    this.hasPlans = result.length > 0;
  }

  async togglePlanStatus(plan: any) {
    this.loading = true;
    const requestedStatus = plan.status === 1 ? 0 : 1;
    try {
      const response: any = await this.apiService.updateSaleItemStatus(
        this.themingService.shopTheming[0].shopId,
        plan.saleId,
        plan.itemId,
        requestedStatus
      );
      if (response?.ok === true) {
        await this.getClientSales();
        if (response.status === 0) {
          $('#successDisaffiliatePlanModal').modal('show');
        } else if (response.status === 1) {
          $('#successAffiliatePlanModal').modal('show');
        } else {
          $('#errorAffiliatePlanModal').modal('show');
        }
      } else {
        this.showErrorModal(requestedStatus);
      }
    } catch (error) {
      console.error('Error updating plan status:', error);
      this.showErrorModal(requestedStatus);
    } finally {
      this.loading = false;
    }
  }

  toggleExpand(plan: any) {
    this.expandedPlanId = this.expandedPlanId === plan.uniqueId ? null : plan.uniqueId;
  }

  private showErrorModal(requestedStatus: number) {
    if (requestedStatus === 0) {
      $('#errorDisaffiliatePlanModal').modal('show');
    } else {
      $('#errorAffiliatePlanModal').modal('show');
    }
  }


  async resendVerificationEmail() {
    const url = 'https://cognito-idp.us-east-1.amazonaws.com/';

    const headers = {
      'Accept-Encoding': 'gzip, deflate, br',
      'Authorization': 'AWS4-HMAC-SHA256 Credential=<Credential>, SignedHeaders=<Headers>, Signature=<Signature>',
      'Content-Type': 'application/x-amz-json-1.1',
      'User-Agent': '<UserAgentString>',
      'X-Amz-Date': '20230613T200059Z',
      'X-Amz-Target': 'AWSCognitoIdentityProviderService.ResendConfirmationCode',
    };

    const body = {
      ClientId: this.amplifyClientConfig.userPoolWebClientId,
      Username: this.client.username,
    };

    fetch(url, {
      method: 'POST',
      headers: headers,
      body: JSON.stringify(body),
    })
      .then(async (response) => {
        if (!response.ok) {
          const errorBody = await response.text();
          throw new Error(`Error ${response.status}: ${errorBody}`);
        }
        return response.json();
      })
      .then((data) => {
        $('#successResendVerificationModal').modal('show');
      })
      .catch((error) => {
        console.error('❌ Error al reenviar el código:', error);
        $('#errorResendVerificationModal').modal('show');
      });
  }

  closeModal() {
    $('#successResendVerificationModal').modal('hide');
    $('#errorResendVerificationModal').modal('hide');
    $('#successAffiliatePlanModal').modal('hide');
    $('#errorAffiliatePlanModal').modal('hide');
    $('#successDisaffiliatePlanModal').modal('hide');
    $('#errorDisaffiliatePlanModal').modal('hide');
  }

}
